/**
 * Phone Cases Dropdown JavaScript
 * Handles dropdown interactivity, swipe gestures, and variant navigation
 */

(function() {
  'use strict';

  const dropdowns = document.querySelectorAll('[data-phone-cases-dropdown]');

  dropdowns.forEach(dropdown => {
    const trigger = dropdown.querySelector('.phone-cases-dropdown-trigger');
    const content = dropdown.querySelector('.phone-cases-dropdown-content');
    const backdrop = dropdown.querySelector('.phone-cases-dropdown-backdrop');
    const items = dropdown.querySelectorAll('.phone-cases-dropdown-item');

    if (!trigger || !content || !backdrop) return;

    let isOpen = false;
    let touchStartY = 0;
    let touchCurrentY = 0;
    let isDragging = false;

    // Toggle dropdown
    function toggleDropdown(open) {
      isOpen = open !== undefined ? open : !isOpen;
      dropdown.setAttribute('data-open', isOpen);
      dropdown.classList.toggle('is-open', isOpen);
      trigger.setAttribute('aria-expanded', isOpen);

      if (isOpen) {
        document.body.style.overflow = 'hidden';
        // Force visibility with inline styles as fallback
        requestAnimationFrame(() => {
          if (!content) return;
          content.style.transform = 'translateY(0)';
          content.style.opacity = '1';
          content.style.pointerEvents = 'auto';
        });
      } else {
        document.body.style.overflow = '';
        if (content) {
          content.style.transform = '';
          content.style.opacity = '';
          content.style.pointerEvents = '';
        }
      }
    }

    // Close dropdown
    function closeDropdown() {
      toggleDropdown(false);
    }

    // Trigger click
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      toggleDropdown();
    });

    // Backdrop click
    backdrop.addEventListener('click', closeDropdown);

    // ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen) {
        closeDropdown();
      }
    });

    // Touch events for swipe to close (mobile)
    content.addEventListener('touchstart', (e) => {
      if (window.innerWidth >= 768) return; // Only on mobile
      
      // Only allow swipe if it starts in the handle or header
      const target = e.target;
      if (!target.closest('.phone-cases-dropdown-handle') && !target.closest('.dropdown-header')) {
        return;
      }
      
      touchStartY = e.touches[0].clientY;
      isDragging = true;
    }, { passive: true });

    content.addEventListener('touchmove', (e) => {
      if (!isDragging || window.innerWidth >= 768) return;
      
      touchCurrentY = e.touches[0].clientY;
      const deltaY = touchCurrentY - touchStartY;

      // Only allow dragging down
      if (deltaY > 0) {
        content.style.transform = `translateY(${deltaY}px)`;
      }
    }, { passive: true });

    content.addEventListener('touchend', () => {
      if (!isDragging || window.innerWidth >= 768) return;
      
      isDragging = false;
      const deltaY = touchCurrentY - touchStartY;

      // Close if dragged down more than 100px
      if (deltaY > 100) {
        closeDropdown();
      } else {
        // Snap back
        content.style.transform = '';
      }

      touchStartY = 0;
      touchCurrentY = 0;
    });

    // Item clicks - handle variant and product selection and navigation
    items.forEach(item => {
      item.addEventListener('click', (e) => {
        const url = item.getAttribute('data-url');
        const handle = item.getAttribute('data-handle');
        const variantId = item.getAttribute('data-variant-id');

        // If it's the current product/variant, just close the dropdown
        if (item.classList.contains('phone-cases-dropdown-item--active')) {
          e.preventDefault();
          closeDropdown();
          return;
        }

        // Navigate to the selected product or variant
        // The href is already set with the correct URL (including ?variant=ID for variants)
        // The default action will work correctly
        
        // Optional: Add loading state
        item.style.opacity = '0.6';
        
        // The browser will navigate via the href attribute
        // For variants: URL already contains ?variant=VARIANT_ID
        // For products: URL is the standard product URL
      });
    });
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', (e) => {
    dropdowns.forEach(dropdown => {
      const trigger = dropdown.querySelector('.phone-cases-dropdown-trigger');
      const content = dropdown.querySelector('.phone-cases-dropdown-content');
      
      if (!dropdown.contains(e.target) && dropdown.getAttribute('data-open') === 'true') {
        dropdown.setAttribute('data-open', 'false');
        dropdown.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        if (content) {
          content.style.transform = '';
          content.style.opacity = '';
          content.style.pointerEvents = '';
        }
      }
    });
  });


    /**
   * Handle selected variant on page load
   * Ensures URL reflects the correct variant and adds `view=sl-XXXX` if needed
   */
  document.addEventListener('DOMContentLoaded', () => {
    try {
      // Get the selected variant ID (from Shopify’s product form or JS object)
      const variantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
      const currentVariantId = variantInput ? variantInput.value : null;

      // Fallback to Shopify Analytics object if available
      const shopifyVariant = window.ShopifyAnalytics?.meta?.selectedVariantId;
      const variantId = currentVariantId || shopifyVariant;

      if (!variantId) return; // No variant found — skip

      const currentUrl = new URL(window.location.href);
      const viewParam = currentUrl.searchParams.get('view');
      const existingVariant = currentUrl.searchParams.get('variant');

      // Generate custom view hash (like sl-C1D67703)
      function generateViewHash(id) {
        // Simple stable hash mimic — you can replace this logic if your views differ
        return 'sl-' + btoa(String(id)).replace(/[^A-Z0-9]/gi, '').substring(0, 8).toUpperCase();
      }

      // Only update URL if missing or incorrect
      if (String(existingVariant) !== String(variantId) || !viewParam) {
        const newView = viewParam || generateViewHash(variantId);
        const newUrl = `${window.location.pathname}?variant=${variantId}&view=${newView}`;
        window.history.replaceState({}, '', newUrl);
      }
    } catch (err) {
      console.warn('Variant URL sync skipped:', err);
    }
  }); 

})();
